<!-- 学员状态 -->
<template>
  <el-form-item :label="label">
    <yx-basic-selector v-bind="config" v-model="status" :type="typeName" clearable/>
  </el-form-item>
</template>

<script>
import { inject } from 'vue';

export default {
  kind: 'yq-学员状态选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: () => [],
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
        };
      },
    },
    label: {
      type: String,
      default: '学员状态：',
    },
    typeName: {
      type: String,
      default: 'studentStatus',
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const status = useQuery('studentsStatus', props.value);

    return {
      status,
    };
  },
};
</script>
